<template>
  <div class="d-flex stepper">
    <template v-for="(step, index) in steps">
      <step
        :step="step"
        :key="step.name"
        :index="index"
        :active="index === activeStepIndex"
        :passed="index < activeStepIndex"
        @click.native="$emit('change-step', index)"
      />
      <div
        v-if="index + 1 !== steps.length"
        class="d-none d-md-block stepper-spacer"
        :class="{'stepper-spacer--active': index < activeStepIndex}"
        :key="index"
      />
    </template>
  </div>
</template>

<script>
import Step from './Step'

export default {
  name: 'Stepper',

  components: {
    Step
  },

  props: {
    steps: {
      type: Array,
      required: true
    },

    activeStepIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss">
.stepper {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $border-color;
  overflow-x: auto;

  &-step {
    height: 56px;
    cursor: pointer;
    padding-bottom: 2px;

    &__icon {
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.5rem;
      margin-top: -1px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: 2px solid $border-color;
      font-size: 12px;

      // if passed and !valid show box

      &--valid {
        background: #0083a1;
        .valid-step {
          width: 10px;
          height: 10px;
          font-size: 0.5rem;
          border-radius: 50%;
          color: white;
          background: transparent;
        }
      }

      &--invalid {
        background: transparent;
        border: none;
      }

      &--error {
        border: none;
        .i {
          font-size: 1rem;
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }

    &--active,
    &--passed {
      border-bottom: 2px solid #0083a1;
      margin-bottom: -1px;
      padding-bottom: 0px;
      .stepper-step__icon {
        border-color: #0083a1;
      }
    }

    &--mobile {
      height: 40px;
      font-size: 12px;
      .i {
        margin: 0 8px;
        width: 10px;
        height: 10px;
      }
    }
  }

  .stepper-spacer {
    flex: 1;
    &--active {
      border-bottom: 2px solid #0083a1;
    }
  }

  @media (max-width: 576px) {
    height: 40px;
    justify-content: left;
  }
}
</style>
